import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import Label from '../typography/label';
import styled from '../../styles/styled';
import { useTheme } from '@emotion/react';
const copyText = (value) => {
    const textarea = document.createElement('textarea');
    textarea.style.height = '0px';
    textarea.value = value ? value.toString() : '';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
};
const CopyButtonStyles = styled.button(({ wasClicked }) => {
    const theme = useTheme();
    return {
        color: wasClicked ? theme.colors.grey20 : theme.colors.azure,
        border: 'none',
        background: 'transparent',
        fontFamily: theme.text.bodyFontFamily,
        fontStyle: 'normal',
        fontWeight: 400,
        marginLeft: theme.space[3],
        fontSize: '14px',
        lineHeight: '18px',
        cursor: 'pointer',
    };
});
export const CopyButton = ({ value, label, ...props }) => {
    const [wasClicked, setWasClicked] = useState(false);
    const onCopyClick = () => {
        copyText(value);
        setWasClicked(true);
        setTimeout(() => setWasClicked(false), 500);
    };
    return (_jsxs(CopyButtonStyles, { onClick: () => onCopyClick(), wasClicked: wasClicked, "data-testid": props['data-testid'], children: ["Copy ", _jsx(Label, { screenReaderOnly: true, children: label })] }));
};
//# sourceMappingURL=copy_button.js.map